import type { ReactNode, Ref, RefObject } from 'react';
import { classNames } from '~/utils/styles';

type DividerProps = {
    vertical?: boolean;
    grow?: boolean;
    spaced?: boolean;
    className?: string;
    children?: ReactNode;
    textVariant?: 'regular' | 'overline';
    ref?: Ref<HTMLElement>;
};

export default function Divider({
    vertical = false,
    grow = false,
    spaced = false,
    className = '',
    children,
    textVariant = 'regular',
    ref,
}: DividerProps) {
    const textVariantClassName =
        textVariant === 'overline'
            ? 'desktop-overline text-core-tertiary'
            : 'desktop-body-2-regular text-core-secondary';
    return (
        <div
            className={classNames({
                'divider-container': true,
                'with-text': Boolean(children),
                divider: true,
                vertical: vertical,
                grow: grow,
                spaced: spaced,
                [className]: Boolean(className),
            })}>
            <hr
                ref={ref as RefObject<HTMLHRElement>}
                className={classNames({ divider: true, vertical: vertical })}
                role='separator'
            />
            <div className={`text hide-empty ${textVariantClassName}`}>{children}</div>
        </div>
    );
}
